import * as Images from './assets/index';

export const socialMediaConfiguration = {
    facebook: {
        reactComponent: Images.Facebook,
        description: 'sharing_link.medium.facebook'
    },
    embed: {
        reactComponent: Images.Embed,
        description: 'sharing_link.medium.embed'
    },
    copy_link: {
        reactComponent: Images.CopyLink,
        description: 'sharing_link.medium.copy_link'
    },
    fb_messenger: {
        reactComponent: Images.FbMessenger,
        description: 'sharing_link.medium.fb_messenger'
    },
    linkedin: {
        reactComponent: Images.Linkedin,
        description: 'sharing_link.medium.linkedin'
    },
    twitter: {
        reactComponent: Images.Twitter,
        description: 'sharing_link.medium.twitter'
    },
    whatsapp: {
        reactComponent: Images.Whatsapp,
        description: 'sharing_link.medium.whatsapp'
    },
    email: {
        reactComponent: Images.Email,
        description: 'sharing_link.medium.email'
    }
};



// WEBPACK FOOTER //
// ./src/components/SocialMedium/conf.js